<div class="flex items-center {{ classNames }}">
  <div
    *ngFor="let item of repetitions; let i = index"
    class="h-4 w-4 text-yellow fill-current {{
      i + 1 > rate ? 'opacity-50' : ''
    }} {{ i > 0 ? 'ml-1' : '' }}"
    [inlineSVG]="'assets/svg/star-s.svg'"></div>
</div>
